export default {
  mainContentId: 'main-content',
};
